module.exports = __webpack_public_path__ + "cfa929732d03d594fda62281664b3243.pdf";